import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import elementui from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import http from './assets/js/http.js' // http请求
import utils from './assets/js/utils.js' // 工具类
import socket from './assets/js/socket.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { connectTest } from './api/baseApi'
import lodash from 'lodash'

// 图片预览组件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './assets/style/global.less'

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { inline: true, button: true, navbar: true, title: true, toolbar: true, tooltip: true, movable: true, zoomable: true, rotatable: true, scalable: true, transition: true, fullscreen: true, keyboard: true, url: 'data-source' }
})

Vue.prototype.$lodash = lodash
Vue.prototype.$http = http
Vue.prototype.$utils = utils
Vue.prototype.$socket = socket
Vue.prototype.$Message = elementui.Message
Vue.prototype.$Loading = elementui.Loading

Vue.use(elementui, { size: 'small' })

Vue.config.productionTip = false

NProgress.configure({ showSpinner: false })

// 服务器链接测试
setTimeout(() => {
  connectTest().then(res => {
    http.callback(res, () => {})
  })
}, 1000)

// 路由拦截
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.path.endsWith('/login')) {
    store.commit('setUser', '')
  }
  // console.log('to', to)
  if (to.meta.requireAuth && to.name !== 'home') {
    const token = store.state.token
    if (token !== undefined && token !== null && token !== '') {
      next()
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})
router.afterEach((to, from, next) => {
  NProgress.done()
})

// 监听localStorage，判断是否有token
window.addEventListener('setItemEvent', function (e) {
  if (e.key === 'Token' && e.newValue) {
    const token = e.newValue
    socket(token)
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
